function getUndefinedStateErrorMessage(key) {
  return (
    `Given change, handler '${key}' returned undefined. 
    To ignore an action, you must explicitly return the previous state.`
  );
}

export default function combineHandlers(handlers) {
  const handlerKeys     = Object.keys(handlers);
  const finalHandlers   = {};
  for (let i = 0; i < handlerKeys.length; i++) {
    const key = handlerKeys[i];
    if (typeof handlers[key] === 'function') {
      finalHandlers[key] = handlers[key];
    }
  }
  const finalHandlerKeys = Object.keys(finalHandlers);

  return function combination(state = {}, change) {
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalHandlerKeys.length; i++) {
      const key                   = finalHandlerKeys[i];
      const handler               = finalHandlers[key];
      const previousStateForKey   = state[key];
      const nextStateForKey       = handler(previousStateForKey, change);
      if (typeof nextStateForKey === 'undefined') {
        const errorMessage = getUndefinedStateErrorMessage(key);
        throw new Error(errorMessage);
      }
      nextState[key]  = nextStateForKey;
      hasChanged      = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? {...state, ...nextState} : state;
  };
}
